import { FC } from 'react';
import { cvaCount, cvaRoot, cvaText } from './ShowMoreButtonStyles';

interface Props {
  text: string;
  count?: number;
  isActive: boolean;
  onClick: () => void;
}

const ShowMoreButton: FC<Props> = ({ text, count, isActive, onClick }) => {
  return (
    <button type={'button'} className={cvaRoot()} onClick={() => onClick()}>
      <span className={cvaText()}>{isActive ? 'Скрыть' : text}</span>
      {count ? <div className={cvaCount()}>{count}</div> : null}
    </button>
  );
};

export default ShowMoreButton;
